<template>
  <div>
    <el-select :value="value !== null&&value !== undefined ? value.toString(): value" value-key="state" :size="size" :placeholder="$t('table.status')" @input="change($event)" :clearable="true">
      <el-option label="----------" value="" />
      <el-option label="待开户" value="0" />
      <el-option label="使用中" value="1" />
      <el-option label="已停开" value="2" />
      <el-option label="已销户" value="3" />
    </el-select>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  props: ['value', 'size', 'showAllTip', 'showAllTipLabel'],
  methods: {
    change: function (val) {
      this.$emit('input', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/card/components/CardStatusSelect.vue